// extracted by mini-css-extract-plugin
export default {"StaleScenarioTag-target":"StaleScenarioTag_StaleScenarioTag-target__9yT-M"};